export default __webpack_public_path__ + "static/media/telemetry-icon.7cb34566.svg";